import "isomorphic-fetch";
import { Promise } from "es6-promise";
Promise.polyfill();

// SCSS imports
// Theme identity
import "./assets";

//Component SCSS files
import "./components";

// Shared JS files
import "../../shared/components/featured-articles";
import "../../shared/components/footer";
import "../../shared/components/form";
import "../../shared/components/header-static";
import "../../shared/components/text";
import "../../shared/components/variants-block";
import "../../shared/components/video";
import "../../shared/components/cookie-bar";

// Shared JS files
import "./components/search-filter-result";
import "./assets/app";
